module.exports = __webpack_public_path__ + "img/logo_westudy_white.b6d44e16.png";